module.exports = __webpack_public_path__ + "img/ícone-calendario.416a0640.svg";